(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('findDisplay', findDisplay);

    function findDisplay(lodash) {
        return function (value, collection, field, display_field) {
            var item = lodash.find(collection, function(_item) {
                return lodash.get(_item, field, null) == value;
            });
            return lodash.get(item, display_field, '');
        };
    }
})();